import { render } from "./ModalZoom.vue?vue&type=template&id=318e4bf6"
import script from "./ModalZoom.vue?vue&type=script&lang=js"
export * from "./ModalZoom.vue?vue&type=script&lang=js"

import "./ModalZoom.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__